/**
 * Timestamp for a chat list row, in the shape a messaging app uses: the time for today,
 * a word for yesterday, the weekday for the rest of the past week, then a date.
 *
 * Differences are counted in calendar days, not 24-hour spans -- 11pm yesterday to 1am
 * today is "Yesterday", not "2 hours ago".
 */
export function formatChatTime(iso: string, now: Date = new Date()): string {
  const d = new Date(iso);
  const days = calendarDaysBetween(d, now);

  if (days === 0) return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit' });
  if (days === 1) return 'Yesterday';
  // Past a week the weekday stops being useful -- "Mon" could be any Monday.
  if (days >= 2 && days <= 6) return d.toLocaleDateString([], { weekday: 'short' });
  return d.toLocaleDateString([], { month: 'short', day: 'numeric' });
}

function startOfDay(d: Date): number {
  return new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime();
}

/** Whole calendar days from `then` to `now`; negative when `then` is in the future. */
function calendarDaysBetween(then: Date, now: Date): number {
  const MS_PER_DAY = 24 * 60 * 60 * 1000;
  return Math.round((startOfDay(now) - startOfDay(then)) / MS_PER_DAY);
}
